<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label class="control-label">Receive SMS notifications (if applicable)?</label>
          <input
            class="form-control"
            type="notification_phone_number"
            name="notification_phone_number"
            v-model="model.notification_phone_number"
            placeholder="Enter ONLY if you want to receive SMS notifications"
          />
          <small>Notifications are optional and not always sent!</small>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label class="control-label">Create a password</label>
          <input
            class="form-control"
            ref="password"
            type="password"
            name="password"
            v-validate="'required|verify_password'"
            v-model="model.password"
            placeholder="create a secure password you can remember!"
          />
          <small class="text-danger" v-show="password.invalid">{{ getError('password') }}</small>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label class="control-label">Repeat</label>
          <input
            class="form-control"
            v-model="model.passwordRepeat"
            type="password"
            name="passwordRepeat"
            v-validate="'required|confirmed:password'"
            placeholder="create a secure password you can remember!"
          />
          <small
            class="text-danger"
            v-show="passwordRepeat.invalid"
          >{{ getError('passwordRepeat') }}</small>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label class="control-label" @click="getTerms">I agree with the terms and conditions</label>
          <br />
          <p-switch
            v-model="model.agreeTermsConditions"
            v-validate="'required'"
            toggle="false"
            name="agreeTermsConditions"
            type="primary"
            value="true"
            on-text="YES"
            off-text="NO"
          >
            <span slot="hover-label">You need to agree!</span>
          </p-switch>
          <small
            class="text-danger"
            v-show="agreeTermsConditions.invalid"
          >{{ getError('agreeTermsConditions') }}</small>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label class="control-label">I'd like to receive newsletters</label>
          <br />
          <p-switch
            v-model="model.newsletter"
            toggle="false"
            name="newsletter"
            type="primary"
            value="true"
            on-text="YES"
            off-text="NO"
          ></p-switch>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapFields } from "vee-validate";
import PSwitch from "src/components/UIComponents/Switch.vue";
import swal from "sweetalert2";
export default {
  components: {
    PSwitch
  },
  computed: {
    ...mapFields([
      "notification_phone_number",
      "password",
      "passwordRepeat",
      "agreeTermsConditions",
      "newsletter"
    ])
  },
  data() {
    return {
      termsConditionsData: "",
      model: {
        notification_phone_number: "",
        password: "",
        passwordRepeat: "",
        agreeTermsConditions: false,
        newsletter: false
      }
    };
  },
  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      return this.$validator.validateAll();
    },
    getTerms() {
      let terms = Webservice.getTermsConditions()
        .then(resp => {
          if (resp.data) {
            swal({
              html: resp.data,
              width: 800
            });
          }
        })
        .catch(error => {
          this.$notify({
            component: {
              template: `<span>An error occured while retrieving the terms and conditions. Please contact us via email or other means</span>`
            },
            icon: "ti-info",
            type: "error"
          });
        });
    }
  }
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Register/FinalStep.vue